import React, { useState } from 'react';
import { Table, ButtonGroup, Button } from 'reactstrap';
import { Row, Col } from 'reactstrap';

import Page from '../../Common/Page';
import ListFromApi from '../ListFromApi';
import MemberRow from './MemberRow';

function MembersPage(props) {
    const [view, setView] = useState('active'); // 'active' vagy 'oregtagok'

    const title = view === 'active' ? 'Aktív tagok' : 'Öregtagok';
    const url = view === 'active' ? '/users/members/active' : '/users/members/oregtagok';
    const errorMessage = view === 'active'
        ? 'Az aktív tagok letöltése sikertelen.'
        : 'Az öregtagok letöltése sikertelen.';

    return (
        <Page centered>
            <h2>Tagjaink</h2>
            <Row className="mb-3">
                <Col>
                    <ButtonGroup>
                        <Button
                            color={view === 'active' ? 'primary' : 'secondary'}
                            onClick={() => setView('active')}
                        >
                            Aktív tagok
                        </Button>
                        <Button
                            color={view === 'oregtagok' ? 'primary' : 'secondary'}
                            onClick={() => setView('oregtagok')}
                        >
                            Öregtagok
                        </Button>
                    </ButtonGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <h4>{title}</h4>
                    <Table size="sm" responsive striped className="table">
                        <thead>
                        <tr className="bg-transparent">
                            <th>Név</th>
                            <th>Tisztség</th>
                            <th colSpan="2">Keresztszülők</th>
                        </tr>
                        </thead>
                        <tbody>
                        <ListFromApi
                            url={url}
                            errorMessage={errorMessage}
                            elementType={MemberRow}
                        />
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </Page>
    );
}

export default MembersPage;
